import { useMutation } from '@tanstack/react-query';
import { seedGlobalEmisisonPreCalculations } from 'services/Emissions.Service';

export const useSeedGlobalEmisisonPreCalculations = () =>
  useMutation({
    mutationFn: ({ accountId }: { accountId: string }) => seedGlobalEmisisonPreCalculations(accountId),
  });
